import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Paperclip, SendHorizontal, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

export const Composer = ({ chat }) => {
  const [text, setText] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const disabled = chat.status !== "chatting";

  const submit = (e) => {
    e.preventDefault();
    if (!text.trim() || disabled) return;
    chat.sendText(text.trim());
    setText("");
  };

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 25 * 1024 * 1024) return toast.error("A fájl max. 25 MB lehet");
    const fd = new FormData();
    fd.append("conversation_id", chat.convRef.current || "");
    fd.append("peer_id", chat.peerIdRef.current || "");
    fd.append("file", f);
    setUploading(true);
    try {
      const { data } = await axios.post(`${API}/upload`, fd);
      chat.sendAttachment(data.file_id);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Feltöltés sikertelen");
    } finally { setUploading(false); }
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2 border-t border-white/10 p-3">
      <input ref={fileRef} type="file" accept="image/*,video/*" hidden onChange={onFile} data-testid="file-attachment-input" />
      <button type="button" disabled={disabled || uploading} onClick={() => fileRef.current?.click()} data-testid="file-attachment-button"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#241E3D] text-[#00F0FF] transition-colors hover:bg-[#2f2752] disabled:opacity-40" title="Kép vagy videó csatolása">
        {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Paperclip className="h-5 w-5" />}
      </button>
      <input value={text} disabled={disabled} maxLength={2000} data-testid="message-input"
        onChange={(e) => { setText(e.target.value); chat.typing(); }}
        placeholder={chat.status === "banned" ? "Ki vagy tiltva" : disabled ? "Várj egy partnerre…" : "Írj valamit…"}
        className="h-11 min-w-0 flex-1 rounded-full border border-white/10 bg-white/5 px-5 text-sm outline-none transition-colors focus:border-[#FF3B6C] disabled:opacity-50" />
      <button type="submit" disabled={disabled || !text.trim()} data-testid="send-message-button"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FF3B6C] text-white transition-transform hover:scale-105 active:scale-95 disabled:opacity-40">
        <SendHorizontal className="h-5 w-5" />
      </button>
    </form>
  );
};
